/*
state = {
    dataFilter: column filters to be applied. It also can include 'ids' attribute 
    in order to display just a subset of insights
    
    projectId: selected project

    topic: selected topic/s. In old links it is a string, in new links it is an array of topic ids
}
*/

const TransformInsightParams = ({ state, children }) => {
    // check if topic attribute is a string, transform it always to an array
    if (typeof state?.topic === 'string') {
        state.topic = [state.topic];
    }

    return children;
};

export default TransformInsightParams;
